module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#group",
      toString: function () {
        return this.url;
      }
    }